import SvgIcon from '../SvgIcon/SvgIcon';

interface SidebarDesktopToggleProps {
  expanded: boolean;
  onToggle: () => void;
  compactHeader?: boolean;
}

const SidebarDesktopToggle: React.FC<SidebarDesktopToggleProps> = ({
  expanded,
  onToggle,
  compactHeader = false,
}) => (
  <button
    type="button"
    onClick={onToggle}
    aria-controls="sidebar"
    aria-expanded={expanded}
    aria-label={expanded ? 'Contraer menú lateral' : 'Expandir menú lateral'}
    title={expanded ? 'Contraer menú lateral' : 'Expandir menú lateral'}
    className="absolute z-9999 hidden h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white bg-primary text-white shadow-lg transition-all duration-300 ease-linear hover:bg-opacity-90 hover:shadow-xl dark:border-boxdark lg:flex"
    style={{
      left: expanded ? '18.125rem' : '5rem',
      top: compactHeader ? '1.625rem' : '2.125rem',
    }}
  >
    <SvgIcon
      name={expanded ? 'panel-left-close' : 'panel-left-open'}
      width={24}
      height={24}
    />
  </button>
);

export default SidebarDesktopToggle;
